<template>
  <div class="card footer-popup">
    <div class="footer-popup-inner">
      <div class="card-header">
        <div class="heading">{{ category.name }}</div>
        <img
          class="close"
          @click="$emit('closePopup')"
          :src="getIcon('close.svg')"
        />
      </div>
      <div class="card-content">
        <template v-if="hasProducts">
          <CardProduct
            v-for="product in products"
            :key="product.id"
            :product="product"
          />
        </template>
        <div class="product not-available" v-else>
          <p>
            {{ $t('AppFooterCategoryPopup.no_category_pieces_added') }}
            <span class="link" @click="goToStep(1)">
              {{ $t('AppFooterCategoryPopup.go_to_step_one') }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import CardProduct from '../products/ProductRow';

export default {
  name: 'AppFooterCategoryPopup',

  components: {
    CardProduct,
  },

  props: {
    category: {
      type: Object,
      default: () => ({}),
    },
    products: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters('build', {
      buildProducts: 'products',
    }),
    ...mapGetters('category-products', ['getProductsByCategory']),

    hasProducts() {
      return this.products.length > 0;
    },
  },
  methods: {
    ...mapMutations('step', ['setStep']),
  },
};
</script>
